import { Col, Form, Button } from "@themesberg/react-bootstrap";
import styled from "styled-components";

const StyledSelect = styled(Form.Select)`
  option:first-child {
    display: none;
  }
`;

const CustomCol = styled(Col)`
  @media (max-width: 819px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (min-width: 820px) and (max-width: 1045px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

const ResponsiveTitle = styled.h2`
  font-size: 1.5rem;
  color: inherit;
  font-weight: 600;
  
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const HeaderSection = styled.div`
  margin-top: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
`;

const AddButtonStyled = styled(Button)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
    
    @media (max-width: 768px) {
      width: 100%;
      padding: 0.5rem;
      font-size: 0.9rem;
    }
    
    svg {
      margin-right: 0.5rem;
      
      @media (max-width: 576px) {
        margin-right: 0.25rem;
        font-size: 1.2rem;
      }
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const TableContainer = styled.div`
  margin-top: 1.5rem;
  overflow-x: auto;
  background-color: var(--bs-table-bg, #fff);
  border-radius: 0.25rem;
`;

export { StyledSelect, CustomCol, ResponsiveTitle, HeaderSection, AddButtonStyled, ButtonContainer, TableContainer };
